import {onDomReady} from "../../components/dynamic/observer";
import Swiper, {EffectCreative, EffectFade, Navigation, Pagination} from "swiper";

onDomReady(() => {
    document.querySelectorAll('[data-index-actions-slider]')
        .forEach((el) => {
            const textSlider = new Swiper(el.querySelector('[data-index-actions-slider-text]'), {
                modules: [Pagination, Navigation, EffectCreative],
                effect: "creative",
                creativeEffect: {
                    prev: {
                        translate: [0, '-20px', 0],
                        opacity: 0,
                    },
                    next: {
                        translate: [0, '20px', 0],
                        opacity: 0,
                    },
                },
                loop: false,
                rewind: true,
                allowTouchMove: false,
                preventInteractionOnTransition: true,
                speed: 1000,
                pagination: {
                    el: el.querySelector('[data-index-actions-slider-pagination]'),
                    type: "fraction",
                },
                navigation: {
                    prevEl: el.querySelector('[data-index-actions-slider-left]'),
                    nextEl: el.querySelector('[data-index-actions-slider-right]'),
                },
            });

            const imageSlider = new Swiper(el.querySelector('[data-index-actions-slider-images]'), {
                modules: [EffectFade],
                speed: 1000,
                allowTouchMove: false,
                loop: false,
                rewind: true,
                effect: "fade",
            });

            textSlider.on('activeIndexChange', () => {
                imageSlider.slideTo(textSlider.activeIndex);
            })
        })
});